/**
 * The shapes the Measure tool places, their two families and the colour of
 * each family. No runtime imports: the e2e specs load this module in Node.
 */

export type MeasureMode =
    | 'distance'
    | 'angle'
    | 'profile'
    | 'circle'
    | 'rectangle';

/** Size shapes measure geometry; intensity shapes read the image. */
export type MeasureFamily = 'size' | 'intensity';

export const MEASURE_FAMILY_OF: Readonly<Record<MeasureMode, MeasureFamily>> = {
    distance: 'size',
    angle: 'size',
    profile: 'intensity',
    circle: 'intensity',
    rectangle: 'intensity',
};

/** Whether `mode` places a region, whose figures are read inside it. */
export const isRegionMode = (
    mode: MeasureMode
): mode is 'circle' | 'rectangle' => mode === 'circle' || mode === 'rectangle';

/** Every mode, in the tray's order. */
export const MEASURE_MODES = Object.keys(MEASURE_FAMILY_OF) as MeasureMode[];

/** Equals the theme's SECONDARY_COLOR. */
export const SIZE_FAMILY_COLOR = '#f49800';
export const INTENSITY_FAMILY_COLOR = '#5AB4FF';

const MEASURE_FAMILY_COLOR: Readonly<Record<MeasureFamily, string>> = {
    size: SIZE_FAMILY_COLOR,
    intensity: INTENSITY_FAMILY_COLOR,
};

/** The colour of `mode`'s family. */
export const measureModeColor = (mode: MeasureMode): string =>
    MEASURE_FAMILY_COLOR[MEASURE_FAMILY_OF[mode]];
